import axios from 'axios';


export const loginUser = (credentials) => async (dispatch) => {
  try {
    const response = await axios.post('https://dm-control.ru:5000/login', credentials);
    const { token } = response.data;
    localStorage.setItem('token', token);
    dispatch({ type: 'LOGIN_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'LOGIN_FAILURE', payload: error.message });
  }
};


export const registerUser = (username,email,password,surname,name,patronymic,policyAgree) => async (dispatch) => {

  try {
    const response = await axios.post('https://dm-control.ru:5000/register', {username,email,password,surname,name,patronymic,policyAgree});
    dispatch({ type: 'REGISTER_SUCCESS', payload: response.data });
    alert(`Вы успешно зарегистрировались! Подтвердите регистрацию по ссылке в почте.`);
  } catch (error) {
    dispatch({ type: 'REGISTER_FAILURE', payload: error.message });
    alert(`Регистрация завершилась неудачей. Вероятно пользователь с таким логином или почтой уже существует.`);
  }

};

export const logOut=()=>{
  return (dispatch, getState)=>{
    localStorage.removeItem('token');
    localStorage.removeItem('iduser');
    localStorage.removeItem('role');
    dispatch({ type: 'LOGIN_OUT', payload: null });
    dispatch({ type: 'FETCH_DMSDATA_CLEAR' });
    dispatch({ type: 'FETCH_DMIMEIDATA_CLEAR' });
    dispatch({ type: 'FETCH_USERDATA_CLEAR' });
    dispatch({ type: 'REGISTER_CLEAR' });
    dispatch({ type: 'FETCH_USERSDATA_CLEAR' });
  }
}

export const getDms = () => {
  return async (dispatch) => {

  dispatch({ type: 'FETCH_DMSDATA_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get('https://dm-control.ru:5000/api/dms',{
      //params:{userid,userrole},
      headers:{
        Authorization: `Bearer ${token}` // Добавляем токен в заголовок
      },
    });
    dispatch({ type: 'FETCH_DMSDATA_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'FETCH_DMSDATA_FAILURE', payload: error.message });
    throw error;
  }
};
};

export const getVerif =async () => {
  //dispatch({ type: 'FETCH_DMSDATA_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get('https://dm-control.ru:5000/api/verif',{
      //params:{userid,userrole},
      headers:{
        Authorization: `Bearer ${token}` // Добавляем токен в заголовок
      },
    });
    return response;
  } catch (error) {
    
  }
};

export const getUserData = () => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_USERDATA_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    if (!token){return}
    const response = await axios.get('https://dm-control.ru:5000/api/userdata',{
      headers:{
        Authorization: `Bearer ${token}` // Добавляем токен в заголовок
      },
    });
    dispatch({ type: 'FETCH_USERDATA_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'FETCH_USERDATA_FAILURE', payload: error.message });
  }
};
};

// преднастройка просмотра в галерее (ДМ, насосные или всё вместе)
export const setViewer = (id, num) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_SETVIEWERUSER_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      const data = { id, num };
      const response = await axios.post(
        'https://dm-control.ru:5000/api/setviewer',
        data,
        config
      );
      dispatch({type: 'FETCH_SETVIEWERUSER_SUCCESS', payload: response.data});
    } catch (error) {
      dispatch({type: 'FETCH_SETVIEWERUSER_FAILURE', payload: error.toString()});
    }
  };
};

// запрос данных с конкретного imei
export const getDmImei = (imei) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_DMIMEIDATA_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        dispatch({ type: 'FETCH_DMIMEIDATA_FAILURE', payload: 'Token not found' });
        return;
      }

      const response = await axios.get('https://dm-control.ru:5000/api/dmimei', {
        params: { imei },
        headers: {
          Authorization: `Bearer ${token}`
        },
      },
    );
      dispatch({ type: 'FETCH_DMIMEIDATA_SUCCESS', payload: response.data });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: 'FETCH_DMIMEIDATA_FAILURE', payload: errorMessage });
      throw error;
    }
  };
};

//команда вперед
export const btnReducerForward = (imei) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_BTNFORWARDDATA_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://dm-control.ru:5000/api/btnforward',
        { imei }, // тело запроса
        {
          headers: {
            Authorization: `Bearer ${token}` // заголовки
          }
        },
      );
      dispatch({ type: 'FETCH_BTNFORWARDDATA_SUCCESS', payload: response.data });
    } catch (error) {
      dispatch({ type: 'FETCH_BTNFORWARDDATA_FAILURE', payload: error.message });
    }
  };
};

//команда назад
export const btnReducerRevers = (imei) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_BTNREVERSDATA_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://dm-control.ru:5000/api/btnrevers',
        { imei },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      dispatch({ type: 'FETCH_BTNREVERSDATA_SUCCESS', payload: response.data });
    } catch (error) {
      dispatch({ type: 'FETCH_BTNREVERSDATA_FAILURE', payload: error.message });
    }
  };
};

//команда стоп
export const btnReducerStop = (imei) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_BTNSTOPDATA_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://dm-control.ru:5000/api/btnstop',
        { imei }, // тело запроса
        {
          headers: {
            Authorization: `Bearer ${token}` // заголовки как третий аргумент
          }
        },
      );
      dispatch({ type: 'FETCH_BTNSTOPDATA_SUCCESS', payload: response.data });
    } catch (error) {
      dispatch({ type: 'FETCH_BTNSTOPDATA_FAILURE', payload: error.message });
    }
  };
};

//настройка дождевальной машины (все настройки)
export const writesettings = (imei, inputvalue, num) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_WRITESETTINGSDATA_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      const data = { imei, inputvalue, num };
      const response = await axios.post(
        'https://dm-control.ru:5000/api/writesettings',
        data,
        config
      );
      dispatch({type: 'FETCH_WRITESETTINGSDATA_SUCCESS', payload: response.data});
    } catch (error) {
      dispatch({type: 'FETCH_WRITESETTINGSDATA_FAILURE', payload: error.toString()});
    }
  };
};

//команда обучение GeoLink
export const btnReducerGeoLink = (imei) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_BTNSTOPDATA_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/btnGeoLink',
      { imei }, // тело запроса
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_BTNSTOPDATA_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'FETCH_BTNSTOPDATA_FAILURE', payload: error.message });
  }
};
};

//запрос баланса и номера вставленной симки
export const networkquestion = (imei, num) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_NETWORKQUESTIONDATA_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      const data = { imei, num };
      const response = await axios.post(
        'https://dm-control.ru:5000/api/networkquestion',
        data,
        config
      );
      dispatch({type: 'FETCH_NETWORKQUESTIONDATA_SUCCESS', payload: response.data});
    } catch (error) {
      dispatch({type: 'FETCH_NETWORKQUESTIONDATA_FAILURE', payload: error.toString()});
    }
  };
};


//команда select_send_sms
export const btnSelect_send_sms = (imei,inputvalue) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_SELECTSENDSMSDATA_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/selectsendsms',
      {imei,inputvalue},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_SELECTSENDSMSDATA_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'FETCH_SELECTSENDSMSDATA_FAILURE', payload: error.message });
  }
};
};

//настройка команды управления и настройка насосной (все настройки)
export const writeRsCmdSettings = (imei, inputvalue, num) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_WRITERSCMDSETTINGSDATA_REQUEST' });
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      const data = { imei, inputvalue, num };
      const response = await axios.post(
        'https://dm-control.ru:5000/api/writeRsCmdSettings',
        data,
        config
      );
      dispatch({type: 'FETCH_WRITERSCMDSETTINGSDATA_SUCCESS', payload: response.data});
    } catch (error) {
      dispatch({type: 'FETCH_WRITERSCMDSETTINGSDATA_FAILURE', payload: error.toString()});
    }
  };
};

// Добавить новый IMEI
export const addimei = (inputvalue, num) => {
 return async (dispatch) => {
 dispatch({ type: 'FETCH_ADDIMEI_REQUEST' });
 try {
  const token = localStorage.getItem('token');
   const response = await axios.post('https://dm-control.ru:5000/api/addimei',
    {inputvalue, num},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
  );
   dispatch({ type: 'FETCH_ADDIMEI_SUCCESS', payload: response.data });
   alert(response.data.message);
  //  console.log(response.data.message);
 } catch (error) {
   dispatch({ type: 'FETCH_ADDIMEI_FAILURE', payload: error.message });
 }
};
};

// Удалить  IMEI
export const delimei = (inputvalue) => {
 return async (dispatch) => {
 dispatch({ type: 'FETCH_DELIMEI_REQUEST' });
 try {
  const token = localStorage.getItem('token');
   const response = await axios.post('https://dm-control.ru:5000/api/delimei',
    {inputvalue},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
  );
   dispatch({ type: 'FETCH_DELIMEI_SUCCESS', payload: response.data });
   alert(response.data.message);
 } catch (error) {
   dispatch({ type: 'FETCH_DELIMEI_FAILURE', payload: error.message });
 }
};
};

// Сброс  IMEI
export const resetimei = (inputvalue,userid,num) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_RESETIMEI_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/resetimei',
      {userid, inputvalue, num},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_RESETIMEI_SUCCESS', payload: response.data });
    alert(response.data.message);
  } catch (error) {
    dispatch({ type: 'FETCH_RESETIMEI_FAILURE', payload: error.message });
  }
 };
 };
 
//получить список пользователей
 export const getUsers = () => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_USERSDATA_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get('https://dm-control.ru:5000/api/getusers',{
      headers:{
        Authorization: `Bearer ${token}` // Добавляем токен в заголовок
      },
    });
    // console.log(response.data);
    dispatch({ type: 'FETCH_USERSDATA_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'FETCH_USERSDATA_FAILURE', payload: error.message });
  }
};
};

// перемещение  IMEI
export const relocate = (inputvalue,userid) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_RELOCATE_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/relocate',
      {userid,inputvalue},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_RELOCATE_SUCCESS', payload: response.data });
    alert(response.data.message);
  } catch (error) {
    dispatch({ type: 'FETCH_RELOCATE_FAILURE', payload: error.message });
  }
 };
 };

 // Удалить  пользователя
export const deluser = (inputvalue) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_DELUSER_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/deluser',
      {inputvalue},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_DELUSER_SUCCESS', payload: response.data });
    alert(response.data.message);
  } catch (error) {
    dispatch({ type: 'FETCH_DELUSER_FAILURE', payload: error.message });
  }
 };
 };

  // Редактировать  пользователя
export const edituser = (value,usernameNew,surnameNew,nameNew,patronymicNew,emailNew) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_EDITUSER_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/edituser',
      {value,usernameNew,surnameNew,nameNew,patronymicNew,emailNew},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_EDITUSER_SUCCESS', payload: response.data });
    alert(response.data.message);
  } catch (error) {
    dispatch({ type: 'FETCH_EDITUSER_FAILURE', payload: error.message });
  }
 };
 };

 // Подтвердить пользователя за него
 export const verifuser = (inputvalue) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_VERIFUSER_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/verifuser',
      {inputvalue},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_VERIFUSER_SUCCESS', payload: response.data });
    alert(response.data.message);
  } catch (error) {
    dispatch({ type: 'FETCH_VERIFUSER_FAILURE', payload: error.message });
  }
 };
 }; 

  // Вспомнить пароль
export const restorepassword = (usermail) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_RESTOREUSER_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/restorepassword',
      {usermail},
      {
        headers: {
          Authorization: `Bearer ${token}` // заголовки как третий аргумент
        }
      }
    );
    dispatch({ type: 'FETCH_RESTOREUSER_SUCCESS', payload: response.data });
    alert('Письмо для восстановления пароля отправлено на ваш email.');
  } catch (error) {
    // console.log(error.message);
    dispatch({ type: 'FETCH_RESTOREUSER_FAILURE', payload: error.message });
  }
 };
 };

   // Изменить пароль
export const changepassword = (password,sendtoken) => {
  return async (dispatch) => {
  dispatch({ type: 'FETCH_CHANGEPASSWORDDATA_REQUEST' });
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post('https://dm-control.ru:5000/api/changepassword',
      {password,sendtoken}
    );
    dispatch({ type: 'FETCH_CHANGEPASSWORDDATA_SUCCESS', payload: response.data });
    console.log('Пароль');
    alert('Пароль успешно изменен!');
    console.log('изменен!');
  } catch (error) {
    console.log("ошибка");
    dispatch({ type: 'FETCH_CHANGEPASSWORDDATA_FAILURE', payload: error.message });
  }
 };
 };